import { FormControl, Grid, Typography } from "@mui/material";

import {
  CenteredGridItem,
  GridItemsContainer,
} from "../../../common/components/functional/FilterSearchField/styled";
import { ReactElement } from "react";

interface Props {
  label: string;
  children: ReactElement | ReactElement[];
}

export const FilterRow = ({ label, children }: Props) => {
  return (
    <CenteredGridItem item container spacing={2} xs={12}>
      <Grid item xs={4}>
        <Typography align="right">{label}</Typography>
      </Grid>
      <GridItemsContainer item xs={8}>
        <FormControl
          fullWidth
          size="small"
          sx={{ flexDirection: "row", alignItems: "center" }}
        >
          {children}
        </FormControl>
      </GridItemsContainer>
    </CenteredGridItem>
  );
};
